import { env } from '@/lib/env'

/**
 * Full expected HPP origin (scheme + host) for the resolved env.
 * Returns `null` when `env.HPP_DOMAIN_NAME` is empty — callers should
 * skip attaching the inbound `postMessage` listener in that case
 * (the `/hpp-session` route still works via `?showButton=1`).
 */
export function expectedHppOrigin(): string | null {
  if (!env.HPP_DOMAIN_NAME) return null
  if (env.HPP_DOMAIN_NAME.startsWith('http://localhost')) return env.HPP_DOMAIN_NAME
  return `https://${env.HPP_DOMAIN_NAME}`
}
